module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/contact-8daee9770aab6463b3a486281613944b.svg&quot;;"